module.exports = __webpack_public_path__ + "static/media/header_video.3e99451.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/header_video.mp4
// module id = rvQi
// module chunks = 1